import React, { useContext } from 'react';
import 'fontsource-roboto';
import './App.css';
import Dashboard from './Components/Dashboard';
import { UserContext } from './providers/UserProvider';
import { SignIn } from './Components/SignIn';

function App() {

  const { initializing, user } = useContext(UserContext);

  if (initializing) {
    return null;
  }

  return (
    <div className="App">

      {!user &&
        <SignIn />
      }
      {user &&
        <Dashboard />
      }

    </div>
  );
}

export default App;


